import user from '../store/user/index'
function getIdName () {
  let type = user.state.userinfo.user.channelType
  let text = '编码'
  if (type === 'CHANNEL_TYPE_DD') {
    text = '多多ID'
  } else if (type === 'CHANNEL_TYPE_MT') {
    text = '美团ID'
  } else if (type === 'CHANNEL_TYPE_XS') {
    text = '兴盛ID'
  }
  return text
}
// 权限检查方法
export default function idName (value) {
  if (user.state.userinfo.user) {
    return getIdName()
  } else {
    setTimeout(() => {
      return getIdName()
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/utils/idName.js